import type { PrijsfavorietenPayload, PrijsfavorietenWeek } from '../report';

type Campaign = PrijsfavorietenPayload['campaign'];

/*
 * Week strip — one cell per campaign week (the mechanic rotates weekly inside a
 * single period), headed by the period name and the calendar weeks it spans.
 * Weeks that haven't started render muted with "· gepland". A "today" marker is
 * positioned by campaign progress.
 */
export function PeriodStrip({ campaign, weeks }: { campaign: Campaign; weeks: PrijsfavorietenWeek[] }) {
  const pct = campaign.totalDays > 0 ? Math.min(100, (campaign.currentDay / campaign.totalDays) * 100) : 0;
  return (
    <div className="period-strip">
      <div className="pf-strip-head">
        <span className="pf-strip-period">{campaign.periodLabel}</span>
        <span className="pf-strip-weeks">{campaign.calendarWeeks}</span>
      </div>
      <div className="period-strip-track pf-period-track">
        {weeks.map((w, i) => (
          <div key={w.label} className={`period-strip-half pf-period${w.planned ? ' pf-period-planned' : ''}`} data-index={i}>
            <span className="period-strip-label">
              {w.label}
              {w.planned && ' · gepland'}
            </span>
            <span className="period-strip-dates">{w.dates}</span>
          </div>
        ))}
        {campaign.currentDay > 0 && (
          <div className="period-strip-marker" style={{ left: `${pct}%` }}>
            <span>Vandaag · dag {campaign.currentDay}</span>
          </div>
        )}
      </div>
    </div>
  );
}
